import { GetterTree } from 'vuex';
import { UserState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<UserState, RootState> = {
  isLoggedIn(state: UserState) {
    return state.id != -1;
  },

  token(state: UserState) {
    return state.token;
  },
};
